import { Select } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceSelect",
  //extends: Select,
  mixins: [Select, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
